import { months } from 'utils/date';

const highlightedDays = {
  BotheredByFatigue : {
    2  : 'No',
    5  : 'Very',
    7  : 'Extremely',
    14 : 'No',
    17 : 'Extremely',
    20 : 'No',
    22 : 'Not at all',
    23 : 'A little',
    28 : 'Somewhat',
  },
  PainIntensity : {
    2  : 'Mild',
    5  : 'Severe',
    7  : 'Very Severe',
    14 : 'Mild',
    17 : 'Very Severe',
    20 : 'Mild',
    22 : 'Moderate',
  },
};

const colorMapping = {
  BotheredByFatigue : {
    No : {
      color      : '#FFFFFF',
      background : '#FFC700',
    },
    'Not at all' : {
      background : '#BDE6E6',
    },
    'A little' : {
      background : '#BDE6E6',
    },
    Somewhat : {
      background : '#91C4C6',
    },
    Very : {
      color      : '#FFFFFF',
      background : '#42969B',
    },
    Extremely : {
      color      : '#FFFFFF',
      background : '#205256',
    },
  },
  PainIntensity : {
    Mild : {
      background : '#A3CF5E',
    },
    Moderate : {
      background : '#00778B',
    },
    Severe : {
      background : '#E37A3F',
    },
    'Very Severe' : {
      background : '#E04229',
    },
    No : {
      color      : '#FFFFFF',
      background : '#FFC700',
    },
  },
};

const shortMonths = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

function monthDiff (d1, d2) {
  var months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
}

export const getCalendars = (periodType, start, end) => {
  let numOfMonths = 4;
  if (periodType === 'Last_4_months') {
    numOfMonths = 4;
  }
  if (periodType === 'Last_6_months') {
    numOfMonths = 6;
  }
  if (periodType === 'Last_12_months') {
    numOfMonths = 12;
  }
  var endingDate = new Date();

  if (periodType === 'Custom' && start != null && end != null) {
    const startPeriod = start.split(' ');
    const endPeriod = end.split(' ');

    const startMonth = parseInt(shortMonths.indexOf(startPeriod[0]) + 1);
    const startYear = `20${startPeriod[1]}`;
    const startDate = new Date(startYear, startMonth, 1);

    const endMonth = parseInt(shortMonths.indexOf(endPeriod[0]) + 1);
    const endYear = `20${endPeriod[1]}`;
    const endDate = new Date(endYear, endMonth, 1);
    if (startDate > endDate) {
      return [];
    }

    endingDate = endDate;
    const monthDifference = monthDiff(startDate, endDate) + 1;
    numOfMonths = monthDifference;
  }

  let calendars = [];
  var months = [];
  for (var i = numOfMonths; i > 0; i -= 1) {
    let d = new Date(endingDate.getFullYear(), endingDate.getMonth() - i, 1);
    months.push({ m: d.getMonth() + 1, y: d.getFullYear() });
  }

  months = months.reverse();

  months.map((monthData) => {
    // TODO: remove this with real data, for now used to showcase purposes of empty calendar data
    let days = monthData.m === 5 ? null : highlightedDays;
    return calendars.push({
      month           : monthData.m,
      year            : monthData.y,
      highlightedDays : days,
      colorMapping,
    });
  });

  return calendars;
};

export const getCustomCalendars = () => {
  const today = new Date();
  const end = today.toLocaleString('default', { month: 'short', year: '2-digit' });
  const startMonth = new Date(today);
  startMonth.setMonth(today.getMonth() - 11);
  const start =  startMonth.toLocaleString('default', { month: 'short', year: '2-digit' });
  const calendars = getCalendars('Custom', start, end);
  return calendars.map((calendar) => {
    return {
      id    : `${months[calendar.month - 1]}  ${calendar.year}`,
      value : `${months[calendar.month - 1].substring(0, 3)}  ${calendar.year
        .toString()
        .substring(2)}`,
    };
  }).reverse();
};

export const mockCategories = {
  BotheredByFatigue : {
    yes : [
      { category: 'A little', color: '#BDE6E6' },
      { category: 'Somewhat', color: '#91C4C6' },
      { category: 'Very', color: '#42969B' },
      { category: 'Extremely', color: '#205256' },
    ],
    no : [{ category: 'No', color: '#FFC700' }],
  },
  PainIntensity : {
    yes : [
      { category: 'Mild', color: '#A3CF5E' },
      { category: 'Moderate', color: '#00778B' },
      { category: 'Severe', color: '#E37A3F' },
      { category: 'Very severe', color: '#E04229' },
    ],
    no : [],
  },
};

export const getCategories = (periodType) => {
  return mockCategories[periodType];
};

export const mockPeriodOptions = [
  { id: 1, label: 'Last 12 months', value: 'Last_12_months' },
  { id: 2, label: 'Last 6 months', value: 'Last_6_months' },
  { id: 3, label: 'Last 4 months', value: 'Last_4_months' },
  { id: 4, label: 'Custom', value: 'Custom' },
];

export const mockCategoryOptions = [
  {
    id    : 1,
    label : 'Bothered by fatigue',
    value : 'BotheredByFatigue',
  },
  // {
  //   id: 2,
  //   label: 'Bothered by pain',
  //   value: 'BotheredByPain',
  // },
  {
    id    : 3,
    label : 'Pain intensity',
    value : 'PainIntensity',
  },
  // {
  //   id: 4,
  //   label: 'Missing work',
  //   value: 'Missing_work',
  // },
  // {
  //   id: 5,
  //   label: 'Missing work/school/social events',
  //   value: 'Missing_work/school/social_events',
  // },
];
